import gql from 'graphql-tag';

export default gql`
mutation AddUserImage(
        $uuid: String!,
        $name: String!,
        $isVertical: Boolean,
        $type: String,
        ) {
    addUserImage(input:{
        uuidUser: $uuid,
        name: $name,
        isVertical: $isVertical,
        type: $type,
    }) {
        __typename
        uuid
        signedUrl
    }
}
`;
